import useTableData from "../../../../state/table/UseTableData";

const useTableTopRow = () => {
  const { tableState } = useTableData();

  return {
    sortedDataTotal: tableState.sortedData?.length || 0,
  };
};

export default useTableTopRow;